import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button } from '@mui/material';
import { useCallback } from 'react';
import Select from 'react-select';
import AgGridTable from 'src/app/main/utilities/AgGridTable';
import { useEffect } from 'react';
import customStyles from 'app/shared-components/SelectCustomStyle';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { useParams } from 'react-router-dom';


/* -------------------------------- Select Vendors -------------------------------- */
const SelectEditorComponent = forwardRef((props, ref) => {
    const refVendor = useRef();
    const [error, setError] = useState("")
    const [vendors, setVendors] = useState([]);
    const [vendorLink, setVendorLink] = useState("");
    const [vendorShortKey, setVendorShortKey] = useState("");
    const [openCom, setOpenCom] = useState(false);
    const getVendorsList = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
        try {
            const list = await OAuthService.getList(url + `?size=1000`);
            let factoryVendorData = list.data?._embedded?.factoryVendors;
            factoryVendorData = factoryVendorData.map((vendor) => {
                const name = vendor.name;
                const shortKey = vendor.shortKey;
                const merge = `${name} ${shortKey}`
                return {
                    label: merge,
                    value: vendor.shortKey,
                    link: vendor._links?.self?.href
                }
            })
            setVendors(factoryVendorData);
        } catch (error) {
            setError(error.message);
        }
    }
    useEffect(() => {
        getVendorsList();
        getProduct();
    }, []);

    const handleVendorChange = (value) => {
        if (value) {
            const vendorShortKey = value.map((row) => row.value);
            setVendorShortKey(vendorShortKey);
            setOpenCom(false)
        }
    };

    const getProduct = async () => {
        const productUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.products}`;
        try {
            if (props.data.id) {
                const result = await OAuthService.getEditData(productUrl, props.data.id);
                const product = result?.data;
                const vendorsUrl = product._links?.vendor?.href;
                const getVendor = await OAuthService.getList(vendorsUrl);
                const vendors = getVendor.data._embedded.factoryVendors;
                const vendorShortKey = vendors.map((vendor) => vendor.shortKey);
                setVendorShortKey(vendorShortKey);
            } else {
                setVendorShortKey(props.data.vendor)
            }
        } catch {
            console.log('error', error);
            setError(error.message);
        }
    }

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return vendorShortKey;
            }
        };
    });

    return (
        <div className="w-full" style={{ width: 350 }}>
            <Select
                className="basic-multi-select mb-4"
                name="name"
                required
                ref={refVendor}
                value={vendors.filter(obj => vendorShortKey?.includes(obj.value))}
                onChange={handleVendorChange}
                isMulti
                options={vendors}
                styles={customStyles()}
            />
        </div>

    );

});

const employeeExpensesData = [
    { recruitmentType: "Trademarks", vendorName: "", cost: "" },
]

const EmployeeExpensesDetail = ({ personalInfo, setSnackState, setSuccessMsg }) => {
    const gridRef = useRef();
    const params = useParams();
    const [gridApi, setGridApi] = useState(null);
    const [uploadDocument, setUploadDocument] = useState([]);
    const [employeeExpenses, setemployeeExpenses] = useState(employeeExpensesData);
    const [employeeColumnDefs, setEmployeeColumnDefs] = useState([
        { field: 'recruitmentType', enableRowGroup: true },
        {
            field: 'vendor', width: 50, enableRowGroup: true, cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true, cellEditor: SelectEditorComponent,
        },
        { field: 'cost', enableRowGroup: true },
    ]);

    const onGridReady = useCallback((params) => {
        setGridApi(params);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [employeeColumnDefs]);

    /*------------------------------Inline Row editing options-------------------------------*/

    const onBtAdd = useCallback((event) => {
        const newRow = {}
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        // let index = employeeExpenses.findIndex((row) => row.id === event.node.data.id);
        // const nextIndex = index + 1;
        employeeExpenses.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'recruitmentType')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'recruitmentType',
            });
        }, 800);
    }, []);
    const onBtStartEditing = useCallback((event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'recruitmentType')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'recruitmentType',
        });

    }, []);


    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        employeeExpenses.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
    }, [gridApi, employeeExpenses])

    const getContextMenuItems = (event) => {
        const data = event?.node?.data;
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            {
                name: "Delete Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };


    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        const model = {
            id: data.id ? data.id : "",
            recuitmentType: data.recuitmentType,
            vendor: data.vendor,
            empId: params.id ? params.id : personalInfo.employeeId,
            cost: data.cost,
            rowIndex: event.node.rowIndex,
        }
        if (params.id) {
            if (data.docId) {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.id === event.node.data.id) {
                                item.recuitmentType = data.recuitmentType,
                                item.vendor = data.vendor,
                                item.empId = params.id ? params.id : personalInfo.employeeId,
                                item.cost = data.cost
                        }
                        return item;
                    });
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            } else {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.rowIndex === event.node.rowIndex) {
                                item.recuitmentType = data.recuitmentType,
                                item.vendor = data.vendor,
                                item.empId = params.id ? params.id : personalInfo.employeeId,
                                item.cost = data.cost
                        }
                        return item;
                    })
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            }

        } else {
            if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                const updatedData = uploadDocument.map((item) => {
                    if (item.rowIndex === event.node.rowIndex) {
                            item.recuitmentType = data.recuitmentType,
                            item.vendor = data.vendor,
                            item.empId = params.id ? params.id : personalInfo.employeeId,
                            item.cost = data.cost
                    }
                    return item;
                })
                setUploadDocument(updatedData);
            } else {
                setUploadDocument([...uploadDocument, model]);
            }
        }

    }, [uploadDocument,personalInfo]);

    return (
        <div>
            <div className='flex justify-end mb-16'>
                <Button
                    // onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                    Save Document
                </Button>
            </div>
            <div style={{ height: "500px" }}>
                <AgGridTable
                    columnDefs={employeeColumnDefs}
                    rowData={employeeExpenses}
                    onRowValueChanged={onRowValueChanged}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    editable={true}
                    editType={'fullRow'}
                    paginationPageSize={10}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'employeeExpensesInfo'}
                />
            </div>
        </div>
    )
}

export default EmployeeExpensesDetail